import { ResourceNamesEnum } from '@/services/api/api-service'

export const DEFAULT_SLOGAN_SCALE = 0.618

export const CONTROLS = [
  'ideas',
  'icons',
  'templates',
  'fonts',
  'text',
  'colors',
]

export const ASSET_LIST_NAMES = ['fonts', 'palettes', 'templates']

export const PALETTE_PROPERTIES = [
  'primary',
  'secondary',
  'accent',
  'background',
  'tertiary',
  'quaternary',
]

export const PALETTE_PROPERTIES_OBJECT = PALETTE_PROPERTIES.reduce(
  (keys, key) => ({ ...keys, [key]: '' }),
  {}
)

export const createStoreDefaults = () => ({
  logo_preset: {
    id: '',
    [ResourceNamesEnum.Templates]: null,
    [ResourceNamesEnum.Palettes]: null,
    [ResourceNamesEnum.Wordmark_fonts]: null,
    [ResourceNamesEnum.Slogan_fonts]: null,
    [ResourceNamesEnum.Icons]: null,
    [ResourceNamesEnum.Slogan]: '',
    [ResourceNamesEnum.Wordmark]: '',
    palette_colors: [],
    palette_hex: PALETTE_PROPERTIES_OBJECT,
    // used in the editor's preview
    svg: null,
  },

  logo: {
    id: '',
    [ResourceNamesEnum.Wordmark_fonts]: [],
    [ResourceNamesEnum.Slogan_fonts]: [],
    [ResourceNamesEnum.Wordmark]: '',
    [ResourceNamesEnum.Slogan]: '',
    [ResourceNamesEnum.Icons]: [],
    assets: { palette: PALETTE_PROPERTIES_OBJECT },
  },

  features: [
    'containers',
    'wordmark',
    'template',
    'preview',
    'palette',
    'history',
    'create',
    'slogan',
    'icons',
    'fonts',
  ],
})
